import { render, staticRenderFns } from "./TeacherSpecializationAssignment.vue?vue&type=template&id=314b065e&"
import script from "./TeacherSpecializationAssignment.vue?vue&type=script&lang=js&"
export * from "./TeacherSpecializationAssignment.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSpecializationAssignment.vue?vue&type=style&index=0&id=314b065e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports